// @flow
import isNil from 'ramda/es/isNil';

const action = (type: string, payload?: any) => (isNil(payload) ? { type } : { type, payload });
export default action;
